<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre4">Making Good for Muley</h1>
<p class="calibre6">If there’s a word of truth in that old saying about beauty being only
skin deep, Susie Abernathy was the thinnest-skinned person I ever saw.
I may not be a judge of womanly beauty, and the poetry of my soul may
have been shook loose by pitching broncos, and buried deep under a
coating of alkali dust, but I sure do sabe when a woman is hard to
look at.</p>
<p class="calibre6">Seems to me like it’s human nature for a feller with squirrel-teeth,
no jaw to speak about and a physique like a corn cultivator to marry a
beautiful female, and vice versa—not that “Muley” Bowles qualifies in
the beauty division, but at that I reckon he shaded Susie a little.</p>
<p class="calibre6">Muley was a poetical puncher, of considerable avoirdupois, and he
found Susie a thing of beauty and a joy forever. Susie was a niece of
Zeb Abernathy, who owned a sheep outfit on Willow Creek, and a grouch
toward all cowmen—and Muley punched cows for the Cross J outfit, and
drew forty a month from old man Whittaker.</p>
<p class="calibre6">I’m not belittling Muley’s salary, ’cause I drew the same, and so did
“Telescope” Tolliver and “Chuck” Warner. Back in the dim and distant
past, when cows first come into style, the old-timers got together and
settled the pay of the average cow-hand.</p>
<p class="calibre6">They figured that any normal puncher—if there is such an animal—would
try at least three turns of the roulette wheel, at ten dollars per
turn. That left him ten dollars. He’d buy some tobacco, some red
neckties and perfume, and what was left, at two-bits a drink for
hooch, would just carry him a few inches short of the murder and
sudden death stage.</p>
<p class="calibre6">I’ve just been up to the house to draw my stipend from the old man,
and am on my way back to the bunk-house, when Muley rides in. He’s
humped over in his saddle, like Misery going to a cemetery, and if you
can stamp despair on a full-sized milk-cheese he had it on his face.</p>
<p class="calibre6">He slips his saddle off, turns his bronc into the corral, leans
against the fence and cuts loose the granddaddy of all sighs. There
ain’t many men that you can hear sigh at pointblank range for a
.30-30, but you could with Muley. It was like releasing the air on a
freight train.</p>
<p class="calibre6">I wanders down there and passes the time of day with him, but he don’t
respond. He exhausts deep into his soul once more, and hangs up his
saddle.</p>
<p class="calibre6">“Some of your relatives die, Muley?” I asks.</p>
<p class="calibre6">“Hello, Hen,” says he, sad-like, “I ain’t got no relatives—except one
aunt. I don’t know whether she’s alive or not.”</p>
<p class="calibre6">“Name of Bowles?”</p>
<p class="calibre6">“Nope. Name’s Allender. Maw’s name was Allender, and that’s why I was
named Lemule Allender, and—what do you want to know for?”</p>
<p class="calibre6">“You sighed a couple of times,” I reminds him, and he nods and looks
off across the range.</p>
<p class="calibre6">“Henry, how can I make some money? Regular money. I can’t get along on
forty a month—no more.”</p>
<p class="calibre6">“You aim to marry Susie Abernathy?” I asks.</p>
<p class="calibre6">Muley digs a little trench with the toe of his boot, and shakes his
head, sad-like—</p>
<p class="calibre6">“No-o-o, I reckon not, Hen.”</p>
<p class="calibre6">“Just come from there?” I asks.</p>
<p class="calibre6">“Uh-huh. Listen, Hen: can you keep a secret? I know danged well that
you can’t, but I got to talk to somebody. Me and Susie’s got it all
framed up to get married, but she argues that I got to see Zeb. Susie
ain’t of age yet, and Zeb is her guardian, Sabe?</p>
<p class="calibre6">“Believe me, Henry, if I owned a penitentiary I’d hire Zeb. I’d a
killed him a long time ago if it wasn’t for Susie, ’cause no sheep-man
can tell me where to head in at—dang his old billy-goat face! He’s a
darned——”</p>
<p class="calibre6">“Not to change the subject, Muley,” says I, “but why don’t you ask
him?”</p>
<p class="calibre6">“I did. Do you think I’d feel this way over futures? You’re darn well
right I asked him! Know what he said? He said to me, just like this:
‘Mister Bowles, you keep away from Miss Abernathy. She’s got her
sights set higher than a forty-dollar puncher.’</p>
<p class="calibre6">“That’s what he said, Henry, and then I said: ‘Mister Abernathy,
you’re tilting that gun for her: let her do her own shooting,” and he
said, ‘Your reputation ain’t none too good, and if the Vigilantes ever
organize here Susie would be a widow.’ ‘You wouldn’t know it,’ says I,
‘’cause they’d get you first.’</p>
<p class="calibre6">“Muley,” says I, “which one of you shot first?”</p>
<p class="calibre6">“Neither one. I beat him on the draw, but you can’t kill your
sweetheart’s guardian. It ain’t ethical, Hen. He told me that any old
time I could show enough money to buy out his herd I could have Susie.
I told him I wasn’t in the habit of buying either sheep or wives, and
he said he knowed that without me telling him. Said that no
forty-a-month puncher was ever that foolish.”</p>
<p class="calibre6">“How about Susie—does she love you, Muley?”</p>
<p class="calibre6">“Uh-huh,” he sighs, “she sure does. I don’t know how she can, but she
does.”</p>
<p class="calibre6">“I don’t know either, Muley, but it takes all kinds of folks to make a
world.”</p>
<p class="calibre6">“I been thinking of marriage for a long time,” he sighs, “I been
afraid to ask her, but today she up and kissed me, and that settled
it, Hen. Funny what a little kiss will do thataway. It makes me
desperate.”</p>
<p class="calibre6">“It would have done the same to me, Muley. If a girl like her kissed
me I’d likely turn outlaw. You aim to go to Chicago with that train of
cows?”</p>
<p class="calibre6">“I can’t, Hen. I hope the old man don’t ask me to. You going?”</p>
<p class="calibre6">“No. Telescope and Chuck are going, but the old man wants me to act as
foreman while they’re gone—he’s going, too. I’ll ask him to let you
stay, if you want me to, Muley.”</p>
<p class="calibre6">“I’d love you like a brother, Hen,” he sighs, “I want to be near her.”</p>
<p class="calibre6">That’s Muley. Being of a poetical temperament he has to confide in
folks. If me or Telescope or Chuck got kissed by a lady we’d cherish
the memory to our graves—unless it was Susie, and think of it only
when alone.</p>
<p class="calibre6">I ain’t so bad to look upon, and a lady couldn’t be censured for
giving me a kiss, but when it comes to Telescope and Chuck—well, I
suppose they’ll eventually marry beautiful women.</p>
<p class="calibre6">Telescope is built like a bed-slat, and orates openly that he’s a twig
of the Tolliver tree, which flourished and bought colored help in
Kentucky before the plans were drawn for the pyramids. Chuck Warner
don’t claim nothing, and don’t get sore if you subtract from his
ancestry. He was born west of the Arizona line, and if he descended
from anybody it was Ananias.</p>
<p class="calibre6">Chuck’s legs are as short as his memory, and he was born with the face
of a horse and the trusting eyes of an angel. He never told the truth
but once. A big feller, from down below Mesquite, took him down and
bumped his head on the ground.</p>
<p class="calibre6">“You got enough?” asks the big person, and Chuck howls—</p>
<p class="calibre6">“Plenty!”</p>
<p class="calibre6">“You ain’t lying, are you?” asks the feller, after he lets Chuck up.</p>
<p class="calibre6">Chuck brushes off his clothes and shakes his sore head:</p>
<p class="calibre6">“No! Dang it all! I wasn’t in no position to lie about it!”</p>
<div class="calibre7"></div>
<p class="calibre6">Muley told me that I couldn’t keep a secret, and I didn’t. Me and
Chuck and Telescope rides to town that afternoon, to foller out the
usual program expected of punchers with a month’s pay aboard, and I
tells them about Muley’s troubles.</p>
<p class="calibre6">“He’s more to be censured than pitied,” admits Chuck. “I don’t blame
Zeb, but I do hate a shepherd what thinks a puncher ain’t good enough
for his relatives.”</p>
<p class="calibre6">“Poor Muley,” says Telescope, sad-like, “any man what is just one aunt
shy of being an orphan has my sympathy. I’ll promise you, Hen, that
I’ll do all I can.”</p>
<p class="calibre6">“In Muley’s name I thanks you,” says I, “but if you can’t do it for
Muley don’t do it on my account. I ain’t going to marry her. I just
feel sorry for him. I’d feel sorry for anybody what was in love with
Susie.”</p>
<p class="calibre6">“She ain’t exactly of the vampire type,” agrees Chuck. “Muley’s got
one dead immortal cinch though: nobody’s going to come along and steal
her away from him.”</p>
<p class="calibre6">“Zeb says he’ll have to marry her over his dead body or bring money
enough to buy out his sheep,” says I.</p>
<p class="calibre6">“The latter is the more revolting,” says Telescope. “Tell Muley we’ll
fix it for him after we get back if we have to steal Zeb’s sheep so he
won’t have nothing to sell.”</p>
<p class="calibre6">The next few days we’re a busy crew, loading twenty cars of beef for
Chicago, and we don’t have much time for conversation. Muley is too
fat to herd ’em up the chute, so he sets down cross-legged on top of a
car, and checks off the loads. Zeb Abernathy comes over to the yards
and sets down on top of the fence, along with a lot of other loafers,
and when Telescope sees him he crosses the corral and sets down beside
Zeb.</p>
<p class="calibre6">“Howdy, Zeb,” says Telescope, rolling a smoke. “You going to leave
here after you sells out, or are you going to make your home with
Susie and her husband?”</p>
<p class="calibre6">“Hu-u-u-u-h?” grunts Zeb, amazed-like, “what’s that you said?”</p>
<p class="calibre6">“Haw, haw, haw!” laughed Telescope, slapping Zeb on the back. “You
can’t keep things like that a secret around here, old-timer. What’ll
we bring to the charivari—sheep-shears or tin cans?”</p>
<p class="calibre6">Zeb sets there, working his jaws faster and faster over his tobacco,
and pretty soon he looks up at Muley. Muley grins at him, and nods.
That’s the last straw.</p>
<p class="calibre6">“Muley’s going to buy out Zeb and marry his niece,” slates Telescope
to Johnny Myers, owner of the Triangle brand. “Muley’s going to be a
sheep-king, Johnny.”</p>
<p class="calibre6">All this time Zeb has been getting off the fence, and he’s so mad that
he dances a jig in the dust when he hits the ground.</p>
<p class="calibre6">“Ya-a-a-a-ah!” he whoops, waving his long arms like a swarm of bees
was after him. “Telescope Tolliver, you’re a liar if you think it!
Marry that fat, forty-dollar fool! Buy my herd! Say, he ain’t never
had money enough to buy a wool sock! Ya-a-a-a-ah! You think you’re
funny, don’t you?”</p>
<p class="calibre6">“Ya-a-a-ah!” mimics Chuck, wiggling his ears. “Zebbie, you’re
learning. Now the chorus—ba-a-a-a-a-ah!”</p>
<p class="calibre6">Zeb’s feelings can’t stand no more, so he turns around like a man with
a sore throat, and goes back toward town stiff-legged like a bear with
a peeve on.</p>
<p class="calibre6">“Zeb loves you fellers,” laughs Johnny. “I heard him say this morning
that there’s just five things he hates. One is a rattlesnake and the
other four draws a salary from Whittaker. What’s he sore at you
fellers for? Has the sheep affected his brain?”</p>
<p class="calibre6">“Such a theory is absurd, Johnny,” says I. “It can’t be proved, ’cause
nobody with brains ever mixes up with sheep. You can’t corrupt a
coyote.”</p>
<p class="calibre6">A little later on me and Muley are setting on the fence, when
Telescope climbs up beside us and talks to Muley like a father.</p>
<p class="calibre6">“You realize what this here marriage stuff means, Muley?” he asks.
“You sure you ain’t just sick like a calf for it’s maw?”</p>
<p class="calibre6">“I know my own heart, liver and lights, Telescope,” replies Muley.</p>
<p class="calibre6">“Really love her with all your heart and soul, eh? Say, I’ll bet you’d
turn her down cold if it was to your advantage.”</p>
<p class="calibre6">“You dang well know I wouldn’t!”</p>
<p class="calibre6">“Suppose,” says Telescope, “suppose somebody said to you: ‘Muley, I’ll
give you a year’s salary if you’ll keep away from Susie?’ What would
you do?”</p>
<p class="calibre6">“Me? I’d rise up on my hind legs and inform him that my love ain’t for
sale. Sabe? Not for the salary of a lifetime.”</p>
<p class="calibre6">Telescope thinks it over for a while, and then shakes his head,
sad-like:</p>
<p class="calibre6">“Maybe you would, Muley. I sure hopes you gets them sheep, ’cause you
qualifies for the shepherd class without no fixing. I’ve read about
love making a fool out of a man, but—well, it ain’t no funeral of
mine.”</p>
<p class="calibre6">That night we shakes hands with Telescope and Chuck and the old man,
and wishes them many happy returns of the day.</p>
<p class="calibre6">“Don’t give up the ship, Muley,” advises Telescope. “Do a lot of
thinking while we’re gone, and if you can figure out any way of making
money without robbing a bank, me and Chuck will put her over for you,
eh, Chuck?”</p>
<p class="calibre6">“A stiff upper lip gathers no mustache,” proclaims Chuck, “and a faint
heart never rustled no sheep, Muley. So-long, you pitch-fork puncher.
And, Hen-ree, don’t fall in love. One shepherd in the family is a
plenty.”</p>
<p class="calibre6">Me and Muley rides back to the ranch, but Muley ain’t got much to say.
Love is a queer little animal, and affects folks different. Muley’s
was the dark-blue variety, with circles around the eyes.</p>
<p class="calibre6">The next morning after breakfast Muley gets a sheet of paper and a
pencil, and seems to compose deep-like. After a while he cuts loose a
deep sigh, and looks, dreamy-like, at the ceiling.</p>
<p class="calibre6">“I’m here,” says I. “Can I help you in any way, Muley?”</p>
<p class="calibre6">“I’ve got it,” he sighs. “You can’t appreciate it, ’cause you ain’t
got no finer feelings, but I’ll recite it to you:</p>
<div class="poetry-container">
<div class="poetry">
<div class="stanza">
<div class="verse">“I loved a darling angel,</div>
<div class="indent">And she loved me quite a lot.</div>
<div class="verse">Her ears are like the clam shell,</div>
<div class="indent">And I can forget her not.</div>
<div class="verse">She’s doomed to marry money,</div>
<div class="indent">And my heart will break, I think,</div>
<div class="verse">If I don’t wed this angel,</div>
<div class="indent">I will drown myself in drink.”</div>
</div>
</div>
</div>
<p class="calibre6">“Nice sentiment,” I applauded. “Bobby Burns never had nothing on you
except the long sound of his r’s, but you’ll have to put off your
demise for at least another month. You can’t do an artistic job of
drownding in a couple of dollars’ worth of hooch. If you was to get in
over your depth in liquor, Muley, what brand would you prefer?”</p>
<p class="calibre6">Right then Muley gets sore at me. I finds that you can josh a man
about love just so far, and then he turns like a worm and tries to
bite me.</p>
<div class="calibre7"></div>
<p class="calibre6">For the next few days he writes poetry in the evening, and is absent
most all day. He ain’t a pleasant critter to talk to, so I spends most
of my time playing solitaire. One day down in Paradise I runs across
Susie.</p>
<p class="calibre6">“Seen Muley lately?” I asks, and she shakes her head.</p>
<p class="calibre6">“No. Uncle Zeb ordered him off the ranch, and since then I’ve only
seen him at a distance. He—he said he was going to try and convince
uncle that he’s something more than an ordinary cowboy. Do you think
he can, Mister Peck?”</p>
<p class="calibre6">“Not unless uncle loses his sense of sight. Muley is pining away, day
by day, and unless something comes up to relieve the situation he’ll
be able to go through a door without turning the knob. I know this is
a leading question, Miss Abernathy, but would you marry that Lemuel
Bowles if you had a good chance?”</p>
<p class="calibre6">“Why—er—uh-huh,” says she, nodding her head brave-like, while her ears
get hot enough to light a cigaret on.</p>
<p class="calibre6">“I feel sorry for Muley,” says I, letting her take it any way she
wants to, and then I lopes away, ’cause I sees Zeb coming.</p>
<p class="calibre6">The next morning we ain’t no more than out of bed when in rides old
Paddy Morse. Paddy runs the post-office, along with his little store,
and this is the first time I ever seen him at the Cross J.</p>
<p class="calibre6">“Is Le-mule Allender Bowles to home?” he inquires, peering over his
specs at me.</p>
<p class="calibre6">“Right here, Paddy,” says Muley. “What do you want?”</p>
<p class="calibre6">“Letter for you. Reckon it’s for you, ’cause there ain’t no other
Bowles around this here neck of the woods. You got to sign your full
name, same as on that letter or I can’t let you have it. Sabe?</p>
<p class="calibre6">“This here is a special delivery letter—darn such things! Uncle Sam
forces me to ride plumb up here to deliver this or take the
consequences, which I believe is three hundred days in jail or a
year—sign right on that line. Now, I reckon I’ll go on back. Hope it
ain’t bad news, Muley. Mostly always a letter of that kind or a
telegram means death. Come from Milwaukee. You got any kin in
Milwaukee?”</p>
<p class="calibre6">But Muley has gone back into the house, and Paddy don’t get the
information he seeks.</p>
<p class="calibre6">About fifteen minutes later Muley comes down to the bunk-house, where
I’m putting some rosettes on a new bridle, and he’s got a grin plumb
across his fat face. I glances at him and goes on working.</p>
<p class="calibre6">“Henry,” says he, after a little while, “would you like to have a job
herding my sheep?”</p>
<p class="calibre6">“Your sheep? Sure. I’ll herd all you got in my sleep.”</p>
<p class="calibre6">“I’m going to be the richest man in Yaller Rock County,” he proclaims.</p>
<p class="calibre6">“You better talk lower, Muley,” I advises. “If the county
commissioners hear you talk thataway they’ll way-bill you to the
loco-lodge at Warm Springs.”</p>
<p class="calibre6">“You remember me telling you about my Aunt Agnes, Hen? She died.”</p>
<p class="calibre6">“And left you a sheep?” I asks.</p>
<p class="calibre6">“Sheep—always sheep! Take a look at this.”</p>
<p class="calibre6">He hands me a letter—the one what Paddy brought him, and I looks her
over. The brand opines it to be from Milwaukee, and the top of the
letter proclaims that Frederick &amp; Quincy are lawyers. She listens
something like this:</p>
<blockquote class="calibre8"><div class="calibre9">
<p class="calibre10"><span class="calibre11">Dear Sir:</span></p>
<p class="calibre6">It grieves us to inform you that your aunt, Miss Agnes Allender, of
this city, died on the fifth day of August, 1900.</p>
<p class="calibre6">According to her last will and testament, you, which she designates as
her favorite nephew, will inherit the bulk of her estate, which is
valued at about one hundred thousand dollars.</p>
<p class="calibre6">As you likely know she was a very eccentric person, and her will
imposes you as follows: without receiving a cent of said inheritance
you must, before the fifteenth day of August, 1900, have invested
four-fifths of said hundred thousand dollars in sheep.</p>
<p class="calibre6">She also designates that: the said Lemuel Allender Bowles must not
marry for the space of five years under penalty of forfeiture of
entire inheritance. Also that he take a care for Alfred and Amelia for
the rest of their natural lives. All of the foregoing requests must be
complied with or my estate is to be divided between charitable
institutions aforementioned in my will.</p>
<p class="calibre6">On the fifteenth day of August, 1900, our representative will call on
you and examine your investments. We wish you luck.</p>
</div>
</blockquote>
<p class="calibre6">I hands it back to him, and goes on working.</p>
<p class="calibre6">“Well,” says he, sort of choking-like, “don’t I get congratulated?”</p>
<p class="calibre6">“As soon as I gets time I’m going to feel sorry for you, Muley. How in
thunder can you invest eighty thousand dollars around here, when
everybody knows you ain’t got a cent, and everybody hates sheep. You
can’t get married for five years, and you’ve got to feed, water and
groom Alfred and Amelia all the rest of their natural lives. Wonder
what them twin-sounding things are, Muley?”</p>
<p class="calibre6">Muley sets to thinking it over, and folding and unfolding that letter:</p>
<p class="calibre6">“Since you sympathized with me, things don’t look so rosy,” he admits,
with a deep sigh. “Reckon I missed that marrying part. If Alfred and
Amelia got a fair start they ought to be about due. Reckon I’ll ride
down to Paradise—dang the luck! I’ve torn that letter plumb in two!”</p>
<p class="calibre6">He puts the two pieces in his vest pocket and goes off down to the
corral.</p>
<p class="calibre6">The longer I thinks things over the harder it looks for Muley. Muley
ain’t got the reputation of a saint around here, and can’t even lie so
folks will believe him. Zeb owns all the visible supply of sheep, and
Muley ain’t got no time to spare if he’s going to make good.</p>
<p class="calibre6">Along about noon Muley rides in. He’s got a big bundle under one arm
and a big box under the other. He deposits his plunder on the steps,
and sets down. I sets down beside him to wait until he gets through
sighing, when all to once a squeaky voice yells:</p>
<p class="calibre6">“Way ’round ’em. Shep! Who’s crazy!”</p>
<p class="calibre6">I hops plumb off the steps, and whirls with my gun ready. Muley looks
at me, sad-like, and sighs again—</p>
<p class="calibre6">“That’s Alfred, Henry.”</p>
<p class="calibre6">“Alfred?” I asks. “Alfred who?”</p>
<p class="calibre6">“I don’t know. Nobody introduced me, but it don’t matter—Alfred is a
parrot.”</p>
<p class="calibre6">“Oh!” says I, “what’s Amelia—a lady bug?”</p>
<p class="calibre6">“Naw-w-w! Cat.”</p>
<p class="calibre6">“<i class="calibre12">Squr-r-r-r-reek! Sheep dip! Sheep dip! Har, har, har! Squr-r-reek!</i>”
announces Alfred.</p>
<p class="calibre6">“Hen, what’s the natural life of a parrot?” asks Muley, without
lifting his head.</p>
<p class="calibre6">“I don’t know. Why the question?”</p>
<p class="calibre6">“That letter specifies ‘natural lifetime.’ That’s the joker.”</p>
<p class="calibre6">“Did it say that?”</p>
<p class="calibre6">“Sure did. Wait, I’ll show you.” He fumbles around in his pockets for
a while, and then looks foolish-like at me: “The front half of that
letter is gone, Henry! Now, where in thunder did I drop that?”</p>
<p class="calibre6">He hunts some more but his pockets don’t essay a trace.</p>
<p class="calibre6">“Har, har, har! Way ’round ’em, Shep!” shrieks Alfred, and Muley kicks
the cage off the porch.</p>
<p class="calibre6">“Shut up! You cross between a duck and a phonygraph! You ain’t yelped
nothing but sheep-talk since I got you. No wonder Aunt Agnes died—she
must have had ticks!”</p>
<p class="calibre6">“You ain’t showing proper respect for the dead, Muley,” I reminds him.</p>
<p class="calibre6">“Is that so!” he yelps. “Is that so! Well, dog-gone it, Hen, she
didn’t show no respect for the living when she shipped me these
trinkets, did she? Sending a puncher a sheep-talking buzzard ain’t
showing a whole lot of respect. That cat is so old I’ll have to feed
it on a bottle, and—”</p>
<p class="calibre6">“Sheep dip!” screams Alfred. “Who’s crazy?”</p>
<p class="calibre6">Muley throws his coat over the cage, and slams the whole works into
the house. He follers it inside, and I sets there for a while thinking
things over. The slats on Amelia’s home ain’t none too secure, so I
loosens one end, and as I goes inside the bunk-house I sees Amelia
trotting off toward the barn.</p>
<p class="calibre6">Muley comes down after a while and sets down on the bunk. “Alfred
danged near bit my finger off, and Amelia’s made her getaway, Hen,” he
announces in a sad voice. “Amelia was down there on the corral fence,
making faces at Chuck’s coyote pup, and she offers fight when I tries
to calm her spirits. Aunt Agnes must have been a nut over ferocious
animals.”</p>
<p class="calibre6">“Nevertheless she was your mother’s sister, and left you all her
wealth,” I chides him.</p>
<p class="calibre6">“Yah! Like throwing both ends of a rope to a drownding man, and
forgetting to hang on to the middle. Can’t marry for five—huh!”</p>
<p class="calibre6">He gets up and stomps out of the place, and I opines that Muley’s
inheritance is beginning to bear down upon his immortal soul.</p>
<div class="calibre7"></div>
<p class="calibre6">The next day Hank Padden, who owns the Seven A outfit, shows up, and
sets down with me in the parlor. Muley is washing up, and when Hank
asks for him he yells that he’ll be out in a minute.</p>
<p class="calibre6">“I’m going to make Muley an offer,” says Hank to me, confident-like.
“I hears that he’s going to get married, and I needs a foreman what is
a married man. Sabe? Single men ain’t got nothing to hold ’em down. I
like Muley—dang his fat carcass—and I rides over here to see him.”</p>
<p class="calibre6">“Uh-huh,” says I, ’cause there ain’t nothing else to say, and then
Hank yells at Muley:</p>
<p class="calibre6">“Come out here, you half-ton puncher! I want to talk to you about——”</p>
<p class="calibre6">“Sheep dip! Sheep dip! Har, har, har!”</p>
<p class="calibre6">I know it’s Alfred, but if it don’t sound like Muley I’ll eat my
quirt. Same little wheeze that Muley has in his laugh.</p>
<p class="calibre6">Hank comes to his feet like a shot, and glares at the half-closed
door. He puts on his hat, walks straight out of the door, gets on his
bronc and fogs away from the Cross J.</p>
<p class="calibre6">I hears a crash in the next room, a couple of shrieks, and out comes
Alfred with most of his tail feathers missing. He sails around the
room a couple of times, finally hits the open door, and perches on the
hitch-rack in front of the house.</p>
<p class="calibre6">Muley comes out, with a shotgun in his hand, and glares around.</p>
<p class="calibre6">“Natural lifetime, Muley,” I informs him, and he tosses the gun on the
sofa.</p>
<p class="calibre6">“That bird will be the death of me, Henry!” he wails, “yelping
sheep-talk at Hank Padden is like lighting a cigaret with a stick of
dynamite. What did he want of me?”</p>
<p class="calibre6">“He came over to sympathize with you about your aunt.”</p>
<p class="calibre6">“Oh!” says Muley, blank-like, looking out of the window. “Ain’t this
Wick Smith coming?”</p>
<p class="calibre6">It was Wick. He ties his bronc and comes inside. To hear him talk
you’d think that rheumatism had typhoid-pneumonia and bubonic plague
beat so far that you could cure ’em both with internal applications of
peach pie.</p>
<p class="calibre6">“I got to get away from here,” states Wick, after we discusses the
weather a while. “Every season I lives here brings me that much nearer
the grave. I want to take a pardner into my store, and while I ain’t
decided exactly about it, I comes up here to have a talk with Muley. I
needs new blood in my place, and I got to have a married man, which
has a little money. Sabe?”</p>
<p class="calibre6">“You got any sheep?” I asks.</p>
<p class="calibre6">Wick sets up straight and glares at me.</p>
<p class="calibre6">“Sheep? I’m a merchant—not a shepherd!”</p>
<p class="calibre6">“Wool is good for rheumatism,” says I, offhand-like, trying to smooth
over my mistake.</p>
<p class="calibre6">“If you’re looking for a married man with money you sure got into the
wrong pew, Mister Smith,” states Muley.</p>
<p class="calibre6">“Zeb told me that you had an aunt—” begins Wick, wise-like, and then:</p>
<p class="calibre6">“<i class="calibre12">Squr-r-r-r-reek! Meo-o-o-o-o-ow! Yip, yip, yip!</i>”</p>
<p class="calibre6">First comes Amelia. She’s traveling so blamed fast that she looks like
a string of about six cats. Right behind her comes that coyote pup,
digging deep into his soul for joyful sounds, and behind him,
screeching and screaming comes Alfred, and they invades the parlor.</p>
<p class="calibre6">Wick hops to his feet as they enters, and of course he’s the highest
point in the room. A cat will always hit for elevation—therefore Wick
got Amelia. Me and Muley sort of draws back to keep the score, but
things happens too fast for computation. Amelia draws all four feet
together in Wick’s scalp, the same of which makes Wick wrinkle up his
face, and forget the rheumatism in his legs. The bird and the coyote
don’t do much except cut circles until Wick starts, blind-like to
leave there, and falls over a chair.</p>
<p class="calibre6">Wick turns over once, lands on his hands and knees, and pilgrims out
of the door, with the cat prospecting his dandruff, Alfred hopping up
and down on his back, and the coyote pup hanging on to his coattails,
and skidding along, making little snappy barks of delight.</p>
<p class="calibre6">They all rolls off the porch, where the three animals tangles up,
leaving Wick alone. He forks his bronc in a hurry, and sets there
rubbing the haze out of his eyes.</p>
<p class="calibre6">Amelia is setting a new cross-country record for cats, as she hunts
for a high spot, and the pup is singing along right behind her.</p>
<p class="calibre6">Alfred walks circles around a post for a few seconds, and then
flutters to the top of the hitch-rack. He ruffles up what feathers
he’s got left, cocks his head on one side and screeches:</p>
<p class="calibre6">“Har, har, har! Sheep dip! Who’s crazy?”</p>
<p class="calibre6">“My gosh!” explodes Wick. “That cyclone hit me so hard that I can see
green eagles and hear ’em talk!” and he backs his bronc away,
cautious-like, and leaves us in a hurry.</p>
<p class="calibre6">Me and Muley looks at each other for a while, and then Muley yawns:</p>
<p class="calibre6">“I must have lost that piece of letter where Zeb could find it. Well,
it didn’t say nothing about buying sheep, anyway, Hen.”</p>
<p class="calibre6">“Lucky it didn’t, Muley. If the community thought you intended to
bring eighty thousand dollars’ worth of sheep on to this range you’d
be the honored guest at a cravat party. Your auntie didn’t understand
conditions when she wrote that will, Muley.”</p>
<p class="calibre6">“Why emphasize ‘when she wrote that will,’ Henry!” he asks, sad-like.
“After looking at Alfred and Amelia—well, Henry, there’s a destiny
what shapes our ends.”</p>
<p class="calibre6">Next morning at breakfast we’re interrupted. Comes a thump of feet
outside the door, and a voice yells—</p>
<p class="calibre6">“Hello, the house!”</p>
<p class="calibre6">“Hello the ——!” says I. “That sounds like Zeb Abernathy, Muley.”</p>
<p class="calibre6">Muley steps over and picks up the old man’s shotgun.</p>
<p class="calibre6">“Let him in, Henry,” says he. “If he comes on the prod I’ll scatter
his remains to the four winds.”</p>
<p class="calibre6">I opens the door, and the old pelican bows to me like I was the fourth
king in the deck to enter his hand.</p>
<p class="calibre6">“Howdy, Henry,” says he, and then he happens to see Muley with the
shotgun. “I comes in sorrow not in anger,” he states, “my soul is
filled with contrition.”</p>
<p class="calibre6">“As long as she’s filled with something I’ll save my buckshot,” opines
Muley. “Come on in and rest your ticks, Zeb Abernathy.”</p>
<p class="calibre6">“Nice weather,” observes Zeb, mopping his face with a red
handkerchief. “May rain and it may not. I kind of look for a dry
spell.”</p>
<p class="calibre6">“The Weather Bureau at Washington gets but annual reports, which reach
us too late, so we thanks you for the information,” says Muley.</p>
<p class="calibre6">“I hope I see you both well,” opines Zeb.</p>
<p class="calibre6">“Your eyesight don’t worry me none to speak about,” states Muley. “The
last time I meets up with you I made you throw your gun down the well.
How’s your sentiments concerning me at present?”</p>
<p class="calibre6">“I’m filled with meekness and contrition, as I aforementioned,
Le-mule. It aches my heart to know that I provoked you thataway, and I
pilgrims over here to make amends. Sabe?”</p>
<p class="calibre6">“Why this sudden change of attitude?” inquires Muley, and Zeb sort of
squirms in his chair.</p>
<p class="calibre6">“She comes to me like a yelp in the night,” says he, pious-like, “I
gets to thinking thusly: ‘Le-mule Allender Bowles, I ain’t treated you
right. I hops on to you like a coyote on a carcass, and reviles you
abusive-like, ’cause you desires to marry into my family. I lets my
interest in Susie blind me to her best interests, but now I sheds the
scales off my eyes, and comes out into the sunshine of true
understanding.</p>
<p class="calibre6">“The more I thinks about it, Le-mule, the worse I feels. Youth calls
to youth, and what is stronger than the call of true love? She ain’t
never yelped at me, boys, but I’m a heap wise. While Le-mule is only
getting forty a month now, I feels that in the due course of time
he’ll be a shining light of the community, and maybe go to Congress.”</p>
<p class="calibre6">“Good sentiments, Zeb,” I agrees, “but it will likely be a close race
between the voters and the sheriff to decide whether he goes to Helena
or Deer Lodge.”</p>
<p class="calibre6">“Haw! Haw! Haw!” roars Zeb. “Muley will never go to the penitentiary.”</p>
<p class="calibre6">“Not willingly,” I agrees. “What are your sheep worth today?”</p>
<p class="calibre6">“I have no sheep, Henry,” he grins. “Sold out to a feller from St.
Marie’s basin, and his drive started today. Yep. I’m a civilian now.”</p>
<p class="calibre6">“Got a good price, too,” he grins, when he sees me look foolish-like
at Muley. “Glad I sold. Too much sentiment against sheep. Well, boys,
I reckon I’ll toddle along. I couldn’t sleep until I comes over and
squares myself with Le-mule. Come over and make yourself to home at my
place, Le-mule.”</p>
<p class="calibre6">“Thanks, Zeb-uleon,” says Muley, “I may do that little thing,
Zeb-uleon. How’s Susie, Zeb-uleon?”</p>
<p class="calibre6">“Tolable, Le-mule. She’s pining.”</p>
<p class="calibre6">We watches him ride away, and then Muley spits, reflectively:</p>
<p class="calibre6">“Henry, if that old pelican had called me Le-mule once more I’d have
slaughtered him. He must have found that letter I lost.”</p>
<p class="calibre6">“You ought to invest your money in a detective agency, and run it
yourself. I suppose you’ll go over to see Susie?”</p>
<p class="calibre6">“Dang well know I will! Why not?”</p>
<p class="calibre6">“Go ahead. Go ahead, Muley, and lose a hundred thousand. What’s a
fortune beside her? Your brain ain’t big enough, Muley. When it gets
over forty dollars it all looks alike to you. You take my advice and
buy sheep.”</p>
<p class="calibre6">“Yah-h-h-h!” he blats. “Where?”</p>
<p class="calibre6">“What will you give me if I buy ’em for you?” I asks.</p>
<p class="calibre6">“You? You got a dead aunt, too, Henry?”</p>
<p class="calibre6">“No, but I got brains, and I can buy sheep.”</p>
<p class="calibre6">“Go buy ’em then!” he snaps, “I’m from Missouri—me.”</p>
<div class="calibre7"></div>
<p class="calibre6">Muley rides away in the general direction of his heart’s desire, and I
gets an inspiration. Over in St. Marie’s basin is plenty of sheep, and
I never saw a sheep-man yet what wouldn’t sell out. I like Muley.
Dog-gone his irresponsible heart, I like him. His mind ain’t big
enough to contemplate a hundred thousand dollars, and I feels glad for
him that he’s got a friend like me to make good for him.</p>
<p class="calibre6">I may be rewarded for my efforts, and maybe not, but anyway I’ve
always wanted to handle big money, and show to the world that Henry
Peck could be more than he’s ever showed.</p>
<p class="calibre6">I saddles up Glory and puts a pack on Blazer, and leaves a note for
Muley, telling him that I’ll be back on the fatal day to save him from
ruin. Little Henry is going to be a hero, and hopes to do his heroing
on a commission basis.</p>
<p class="calibre6">I pilgrims over into a country that cowmen designates as being a fair
example of the place where sinners will reside in the hereafter, and
eats mutton and talks sheep.</p>
<p class="calibre6">Believe me I could talk sheep faster than the men that owned the
herds, and I confides in ’em about Muley’s inheritance. Of course I
didn’t tell it all, but anyway I got options on enough sheep to cause
Yaller Rock County to build an extra wing on the insane asylum, and
said options didn’t cost me a cent.</p>
<p class="calibre6">“Old Testament” Tilton rides back with me. I’ve spent about fifteen
thousand of Muley’s credit with him, and being a minister, he’s a
little suspicious of his fellow-men.</p>
<p class="calibre6">“I ride with you for the good of my soul,” orates the old boy, when he
offers to accompany me.</p>
<p class="calibre6">I reckon that when a shepherd goes into cow-land, it’s like taking a
ship into fresh water to knock off the barnacles.</p>
<p class="calibre6">He’s a queer old coot. Imagine a man of his cognomen, add the smell of
sheep, dress him up around the neck like a preacher, tuck his pants
into the top of a pair of heavy boots, and you’ve got a portrait of
Old Testament. He rides a little calico bronc, with one cropped ear
and a rat-tail, and calls it Ebenezer. The only way, I figure, that he
could ever hand out salvation would be by correspondence.</p>
<p class="calibre6">“Now, this here Le-mule Bowles,” remarks the old boy, “do you think I
could induce him to come into the vineyard?”</p>
<p class="calibre6">“Muley will go into anything that’s got a door on it,” says I. “Also,
he’ll take anything what ain’t nailed down.”</p>
<p class="calibre6">“I fear me it will be a task,” he says, sad-like, and then he sort of
brightens up. “Have you ever considered your soul?”</p>
<p class="calibre6">“I have no soul,” says I.</p>
<p class="calibre6">“Say not that you are a lost sheep,” he chides me, and it makes me
sore, and I points off down the valley.</p>
<p class="calibre6">“We’re in cow-land now, old-timer, so you lay off on that lost-sheep
stuff. Sabe? Down here they calls ’em plain strays.”</p>
<p class="calibre6">We plods down into the Sleeping Creek country, and stops at Hank
Padden’s place for dinner. Old Testament and Hank are old friends, but
Hank don’t more than give me a nod. I reckon he ain’t forgot what he
thought was Muley’s voice, and he blames me, too. When we gets ready
to leave Hank acts like I had a contagious disease.</p>
<p class="calibre6">“Drop in any old time, Tilton,” says Hank. “Glad to see you.”</p>
<p class="calibre6">“Me, too, Hank?” I asks, and he gives me a hard look.</p>
<p class="calibre6">“You travels on your own responsibility,” he replies.</p>
<p class="calibre6">“I wonder what Hank is sore at me for?” I asks Old Testament, a little
later, but he shakes his head, and mumbles something about the flocks
on the seven hills and the wrath to come.</p>
<p class="calibre6">“Did you tell him that I bought them sheep?” I asks, and he nods.</p>
<p class="calibre6">“Yea. I did not lie, Henry Peck. I know naught of Bowles.”</p>
<p class="calibre6">“I suppose you also told him that I was going to stock this here range
with sheep, didn’t you?”</p>
<p class="calibre6">“I merely told him that I surmised so.”</p>
<p class="calibre6">We rides almost to the Cross J, when we overtakes Abe Evans, the depot
agent at Paradise.</p>
<p class="calibre6">“Gosh! I’m glad you caught me,” pants Abe, “I never was built to fit a
saddle, and this here nag ain’t no rocking-chair. Here’s a telegram
for Lemule Bowles, charges paid. You sign for it, Hen, and let me go
back home.”</p>
<p class="calibre6">We pilgrims on to the ranch, but Muley ain’t there. There’s a note on
the table which orates that he’ll be there at three o’clock, and it’s
addressed to Weinie Lopp, of the Triangle.</p>
<p class="calibre6">“This here telegram ought to be opened,” opines Old Testament, who is
as nosey as a pet coon. “A telegram always means that something is
going to happen, and it’s better to be prepared.”</p>
<p class="calibre6">I tears the cover off and looks her over. It says—</p>
<div class="calibre3">
<div class="calibre13">Will arrive your town this date meet me with a vehicle. </div>
</div>
<p class="calibre6">And she’s signed Frederick &amp; Quincy.</p>
<p class="calibre6">I looks at my watch and decides on quick action.</p>
<p class="calibre6">“You set down here and rest your feet,” says I to Old Testament, “I’ll
hitch up the buckboard, and go to town. I just got enough time to get
there.”</p>
<p class="calibre6">That was some ride. Them broncs were as wild as deer, and we went to
Paradise so fast that the dust didn’t settle for thirty minutes after
I ties up at the station.</p>
<p class="calibre6">The train is late, so I goes over to Mike Pelly’s place, and washes
the sheep-taste out of my throat. It takes quite a lot of liquid, and
when I goes back to the station I’m sheep-proof.</p>
<p class="calibre6">The train pulls in and I spots my man. There’s quite a crowd at the
station, but I knowed him the minute he got off, and it takes me about
three steps to get where he’s standing. Being sheep-proof, I’m also
polite, so I takes his valise away from him, and starts for the rig.</p>
<p class="calibre6">“Come on, Blackstone,” says I, “your carriage waits without.”</p>
<p class="calibre6">He starts with me, but he seems to complain a heap, so I stops and
asks him whyfore the objections.</p>
<p class="calibre6">“Where the Sam Hill are you taking my bag?” he asks, getting red in
the face. “Who told you to take that valise?”</p>
<p class="calibre6">“Mister,” says I, “don’t excite yourself thataway. I’m doing all I can
to make you comfortable. Sabe? I advises you to come along peaceable,
and anything you may say will be used against you.”</p>
<p class="calibre6">I always thought that lawyers tried to settle things peaceably, but I
don’t reckon this one runs true to form, ’cause he hit me so hard
under the chin that he drove my head right up to the top of my hat.
That hat always was too small, but after that wallop I has to stuff
the sweat-band with paper so she’ll fit.</p>
<p class="calibre6">The train is pulling out when I wakes up, and I sees that fat feller
standing on the rear platform.</p>
<p class="calibre6">“What was you aiming to do, Hen?” asks Bill McFee, our sheriff, who is
setting beside me on the platform.</p>
<p class="calibre6">“That was the feller I was here to meet, Bill,” says I. “He’s sure a
sudden son-of-a-gun for a lawyer.”</p>
<p class="calibre6">“He ain’t no lawyer, Henry,” says Bill. “He’s the railroad paymaster,
and he thought you was trying to steal his roll.”</p>
<p class="calibre6">“Wrong man,” says I. “Seen any stranger get off the train?”</p>
<p class="calibre6">Bill shakes his head, so I pilgrims around to where I tied my rig, and
there sets Telescope, Chuck and the old man. Them three acts like they
was tickled stiff, and Telescope yelps at me—</p>
<p class="calibre6">“Got the telegram, did you, Henry?”</p>
<p class="calibre6">I don’t have nothing to say, and that seems to make ’em more joyful. I
don’t keep silent from choice, but that feller darn near unjointed my
jaw and she hurts like thunder when I opens my face.</p>
<p class="calibre6">“Muley still wearing crape?” asks Chuck, as we ride out of town, and
all three of ’em busts out laughing.</p>
<p class="calibre6">“Danged mean trick,” opines the old man. “You remember Jimmy
Frederick, don’t you, Hen? He was out here a few years ago. He knows
Muley well. We were up in his office and Telescope and Chuck got him
to write that letter.”</p>
<p class="calibre6">“How many sheep has Muley bought on his nerve?” asks Chuck.</p>
<p class="calibre6">“Come on through, Hen. Did he buy out Zeb’s herd? I hope he ain’t got
mutton for our supper.” And then Telescope sings sort of plaintive
like;</p>
<div class="poetry-container">
<div class="poetry">
<div class="stanza">
<div class="verse">“I love a little chicken and I love a little fish.</div>
<div class="verse">When somebody says ‘ham and eggs,’ I pass along my dish,</div>
<div class="verse">When I get good and hungry I could eat a roarin’ bull,</div>
<div class="verse">But when they passes mutton meat my stummick’s full.”</div>
</div>
</div>
</div>
<p class="calibre6">And then Chuck joins in the chorus:</p>
<div class="poetry-container">
<div class="poetry">
<div class="stanza">
<div class="verse">“I’m a tough old rooster, and I’ve eaten snakes,</div>
<div class="verse">I’ve spread giant powder on my buckwheat cakes,</div>
<div class="verse">I’ve drank rawhide stew ’till I was out of breath,</div>
<div class="verse">But when they serves up mutton meat I starves to death.”</div>
</div>
</div>
</div>
<p class="calibre6">“You’re a fine bunch of friends!” I snaps, taking a chance that my jaw
is still on its hinges. “She was his favorite relative, and since that
letter he ain’t done nothing but mope. You’re a danged bunch of ghoul
comedians. Muley’s due to kill somebody when he finds out about it.
What was the main idea?”</p>
<p class="calibre6">“Well,” laughs Telescope, “we made him rich for a while, didn’t we?
Zeb orates that he wants Susie to marry money, so we gave it to him in
a lump. We puts in that marriage clause just to see if Muley loved her
enough to lose the money, Sabe? We knowed danged well that he couldn’t
buy no sheep. What did the parrot have to say, Hen?”</p>
<p class="calibre6">“Told Hank Padden he could use sheep dip.”</p>
<p class="calibre6">“Haw, haw, haw!” whoops Chuck. “Did he honest say that? I sat up all
one night and day trying to teach that parrot some sheep-talk, but all
it ever did was to bite me. Telescope swiped that cat at the depot in
Milwaukee.”</p>
<div class="calibre7"></div>
<p class="calibre6">Just before we reaches the ranch, three people rides in ahead of us
and waits for us to come up. It’s Hank Padden, Johnny Myers and
“Scenery” Sims. They all got rifles.</p>
<p class="calibre6">We exchanges greetings, but they don’t seem glad to see nobody but me.</p>
<p class="calibre6">“We don’t aim to be nosey, Mr. Peck,” says Hank, “but we’d admire to
hear a little more about them sheep.”</p>
<p class="calibre6">“What sheep?” I asks, surprised-like.</p>
<p class="calibre6">“Old Testament told me,” says Hank. “He spoke about you going to start
a herd here and——”</p>
<p class="calibre6">“I thanks you for the compliment,” says I. “It seems nice to be
mistaken for a capitalist, Hank, but what I wants to know is this; how
long since have you been taking the word of a shepherd? Do I need to
deny it?”</p>
<p class="calibre6">“Old Testament must have lied, Hank,” states the old man. “He must
have been crazy to state such a thing. Somebody’s crazy anyway.”</p>
<p class="calibre6">“That’s what I said,” squeaks Scenery. “Hen Peck couldn’t buy a pair
of wool socks.”</p>
<p class="calibre6">They all nods sort of agreeable-like, and he drives on.</p>
<p class="calibre6">“After a while, when there ain’t nobody around to interrupt us, I’m
going to ask you a few questions, Henry,” states Chuck, solemn-like.</p>
<p class="calibre6">“You better bring a witness,” says I. “All I wants is an uninterested
third party present so I can prove I shot in self-defense.”</p>
<p class="calibre6">We pulls up to the ranch. The front door is open and two rigs are tied
out in front. We pilgrims up to the door, and are greeted with some
sight.</p>
<p class="calibre6">There’s Old Testament standing in the middle of the room, with his
eyes rolled toward the rafters, while in front of him stands Susie
Abernathy and Muley Bowles. Muley’s vest is stretched to the bursting
point, and you could light a match on Susie’s freckles.</p>
<p class="calibre6">To one side stands Zeb Abernathy, and on the other stands Weinie Lopp,
all dressed up in a celluloid collar, and no place to put his hands.</p>
<p class="calibre6">We hears Old Testament finish up his prayer, and as Muley folds Susie
to his bosom we troops inside. Muley sees us over Susie’s shoulder,
and breaks the clinch. Zeb grins out through his whiskers and Weinie
Lopp turns up the collar of his coat.</p>
<p class="calibre6">Everything is still for a few seconds, and then Old Testament smiles
at me over his specs:</p>
<p class="calibre6">“My son,” says he, “it’s fortunate that I came with you. I had
considered taking a trip over into the Bitter Roots, and Mister Lopp
would have missed me.”</p>
<p class="calibre6">“Exactly,” says I, having the understanding of a fish. “All very true.
Was Weinie on your trail?”</p>
<p class="calibre6">“Uh-huh,” gurgles Weinie,“I—I was after a preacher for Muley.”</p>
<p class="calibre6">“They—they just got married,” chuckles Zeb. “Just now.”</p>
<p class="calibre6">“Well,” says Chuck, foolish-like, “who gets the first kiss from the
bride—after you, Muley?”</p>
<p class="calibre6">“Muley, you’re a hero!” gasps Telescope. “Any man is a hero who will
sacrifice a hundred thousand dollars at the throne of love. Everybody
take off your hats to Muley Bowles.”</p>
<p class="calibre6">Everybody’s got their hats off so we don’t respond.</p>
<p class="calibre6">“What did you mean by that, Telescope?” gasps Zeb. “Do—do you mean
that he—he’ll lose all that money ’cause he married Susie?”</p>
<p class="calibre6">“You said it, Zeb,” grins Telescope. “Ain’t you proud of him? What a
nephew-in-law!” and then he turns to Muley: “Muley, old-timer, I
didn’t think you had it in you, but you never can tell which way a
dill pickle will squirt. How does it seem to lose a hundred thousand
dollars?”</p>
<p class="calibre6">“Well,” grins Muley, putting one arm around the shrinking bride. “I
ain’t lying to you when I says I don’t know how it feels. You see,
Telescope, the name of Allender don’t cover no branch of my
family-tree, and I never had any Aunt Agnes.”</p>
<p class="calibre6">There’s a painful silence for a minute, and then comes a flutter of
feathers, and in waddles Alfred. He ain’t got no tail-feathers left,
and the rest of his carcass is pretty well plucked. He looks us over,
wild-eyed, ruffles up his remaining foliage, croaks:</p>
<p class="calibre6">“Har, har, har! Who’s crazy?”</p>
<p class="calibre6">Zeb looks wide-eyed at the bird for a moment, and then sneaks past it
and out on the steps:</p>
<p class="calibre6">“I’m going away,” says he in a low, hoarse voice. “Going away before
that bird answers its own questions.”</p>
<p class="calibre6">“Tally three more,” states Telescope, and him and Chuck and the old
man sneaks out.</p>
<p class="calibre6">“Make it five,” says I, and me and Weinie goes out, too.</p>
<div class="calibre14"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?418075f2